import { useNavigate } from "react-router-dom";
import { ShoppingBag, Trash2 } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { useCart } from "@/context/CartContext";
import { formatARS } from "@/lib/api";
import { QtyStepper } from "./QtyStepper";

export const CartSheet = ({ open, onOpenChange }) => {
  const { items, setQty, total } = useCart();
  const navigate = useNavigate();
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="bg-[#1C1515] border-[#2E2323] text-amber-50 rounded-t-3xl max-h-[85vh] overflow-y-auto" data-testid="cart-sheet">
        <SheetHeader className="text-left">
          <SheetTitle className="text-2xl font-extrabold text-amber-50 flex items-center gap-2"><ShoppingBag className="w-6 h-6 text-amber-400" /> Tu pedido</SheetTitle>
          <SheetDescription className="text-[#A89F91]">Revisá tus productos antes de continuar.</SheetDescription>
        </SheetHeader>
        <div className="mt-4 space-y-3 max-w-2xl mx-auto">
          {items.length === 0 && <p className="text-[#A89F91] text-sm py-8 text-center" data-testid="cart-empty">Tu carrito está vacío.</p>}
          {items.map((it, i) => (
            <div key={it.key} className="flex gap-3 p-3 rounded-2xl bg-[#FFFDF9] text-[#1F1917]" data-testid={`cart-item-${i}`}>
              <div className="flex-1 min-w-0">
                <p className="font-bold text-sm leading-tight">{it.name}</p>
                {it.details?.map((d) => <p key={d} className="text-xs text-[#645A53]">{d}</p>)}
                <p className="font-price text-xl text-[#B91C1C] mt-1">{formatARS(it.unit_price * it.qty)}</p>
              </div>
              <div className="flex flex-col items-end justify-between gap-2">
                <button onClick={() => setQty(it.key, 0)} className="text-[#645A53] hover:text-[#DC2626]" data-testid={`cart-item-remove-${i}`}><Trash2 className="w-4 h-4" /></button>
                <QtyStepper light value={it.qty} onChange={(q) => setQty(it.key, q)} testid={`cart-item-qty-${i}`} />
              </div>
            </div>
          ))}
          {items.length > 0 && (
            <button onClick={() => navigate("/checkout")} data-testid="cart-checkout-btn"
              className="sticky bottom-0 w-full mt-2 py-4 shadow-2xl shadow-black/60 rounded-full bg-[#DC2626] hover:bg-[#991B1B] text-white font-bold flex items-center justify-between px-6 transition-colors">
              <span>Continuar con el pedido</span>
              <span className="font-price text-xl" data-testid="cart-total">{formatARS(total)}</span>
            </button>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
};
